export const PasswordResetDTO = {
  password: '',
  confirmPassword: '',
  id: -1,
  token: '',
  userId: '',
  expiry: -1
};
